"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "4",
  height: "6",
  viewBox: "0 0 4 6"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M.1 5.87a.36.36 0 01.04-.53L2.99 3 .14.66A.36.36 0 01.1.13C.24-.03.5-.04.66.09l3.2 2.63c.09.07.14.17.14.28 0 .1-.05.21-.14.28L.66 5.91a.42.42 0 01-.56-.04z"
}));

exports["default"] = _default;